import React, { useState } from "react";
import Button from "../Basic/Button";
import Accordion from "../Basic/Accordion";
import forDoctorIllustrationSrc from "../../assets/illustrations/with-quadrant-doctor.svg";
import forPatientIllustrationSrc from "../../assets/illustrations/with-quadrant-patient.svg";
import bgNavyDarkBottom from "../../assets/background/bg-form-bottom-navy-dark.svg";

const WithQuadrant = () => {
  const [forPatient, setForPatient] = useState(false);

  return (
    <div>
      <div className="px-5 lg:px-10 pt-5 pb-10 lg:py-30 bg-navy-dark -mb-1">
        <div className="w-full lg:max-w-7xl mx-auto relative z-10">
          <h2 className="text-white text-8 lg:text-6xl leading-tight mb-8 lg:mb-16 text-center header w-fit">
            Designed by clinicians, for clinicians.
          </h2>

          <div className="flex flex-col w-full lg:grid grid-cols-2 gap-20">
            <div className="space-y-6">
              <div className="flex items-center space-x-3 mb-8 lg:mb-16">
                <Button
                  variant={forPatient ? "navy" : "green-secondary"}
                  onClick={() => setForPatient(false)}
                >
                  For providers
                </Button>
                <Button
                  variant={forPatient ? "green-secondary" : "navy"}
                  onClick={() => setForPatient(true)}
                >
                  For patients
                </Button>
              </div>

              {forPatient ? (
                <div className="divide-y divide-navy-light">
                  <Accordion title="Reach your team" key="Reach your team">
                    Contact your team via the modality you prefer: SMS,
                    Application, or Call
                  </Accordion>
                  <Accordion
                    title="Get answers quickly"
                    key="Get answers quickly"
                  >
                    Request medication refills, get screenings, and schedule
                    appointments with the press of a button
                  </Accordion>
                  <Accordion
                    title="Receive personalized care"
                    key="Receive personalized care"
                  >
                    Get 24/7 care from a human, enhanced by clinically aware AI
                  </Accordion>
                </div>
              ) : (
                <div className="divide-y divide-navy-light">
                  <Accordion
                    title="Increase Efficiency"
                    key="Increase Efficiency"
                  >
                    Reclaim hours in your team’s day spent on administrative and
                    clinical tasks
                  </Accordion>
                  <Accordion title="Generate Revenue" key="Generate Revenue">
                    Increase profitability with an end-to-end solution for Care
                    Management (CCM, PCM), Remote Monitoring, and Behavioral
                    Health (BHI)
                  </Accordion>
                  <Accordion title="Use One Platform" key="Use One Platform">
                    Integrate with your existing EHR and enhance, not replace,
                    your current workflows
                  </Accordion>
                </div>
              )}
            </div>

            <div className="flex max-w-full lg:max-w-2xl lg:max-h-[428px] items-start justify-center">
              {forPatient ? (
                <img
                  src={forPatientIllustrationSrc}
                  alt="for patient"
                  className="mx-auto max-h-full max-w-[75vw] sm:max-w-md lg:max-w-full object-fill object-center"
                  width="555"
                  height="430"
                />
              ) : (
                <img
                  src={forDoctorIllustrationSrc}
                  alt="for doctor"
                  className="mx-auto max-h-full max-w-[75vw] sm:max-w-md lg:max-w-full object-fill object-center"
                  width="595"
                  height="430"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <img
        src={bgNavyDarkBottom}
        alt="background"
        className="w-full"
        width="1439"
        height="93"
        fetchpriority="high"
      />
    </div>
  );
};

export default WithQuadrant;
